module.exports = __webpack_public_path__ + "img/balance_tension_175.3374564c.jpg";